/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NFSPermission,
    NFSPermissionFromJSON,
    NFSPermissionFromJSONTyped,
    NFSPermissionToJSON,
    ProductionMiniReference,
    ProductionMiniReferenceFromJSON,
    ProductionMiniReferenceFromJSONTyped,
    ProductionMiniReferenceToJSON,
    Quota,
    QuotaFromJSON,
    QuotaFromJSONTyped,
    QuotaToJSON,
    VolumeMiniReference,
    VolumeMiniReferenceFromJSON,
    VolumeMiniReferenceFromJSONTyped,
    VolumeMiniReferenceToJSON,
    WorkspaceEndpoint,
    WorkspaceEndpointFromJSON,
    WorkspaceEndpointFromJSONTyped,
    WorkspaceEndpointToJSON,
    WorkspaceResolvedPermission,
    WorkspaceResolvedPermissionFromJSON,
    WorkspaceResolvedPermissionFromJSONTyped,
    WorkspaceResolvedPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface Workspace
 */
export interface Workspace {
    /**
     * 
     * @type {number}
     * @memberof Workspace
     */
    id: number;
    /**
     * 
     * @type {ProductionMiniReference}
     * @memberof Workspace
     */
    production: ProductionMiniReference;
    /**
     * 
     * @type {VolumeMiniReference}
     * @memberof Workspace
     */
    volume?: VolumeMiniReference;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    readonly volumePath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    readonly path?: string | null;
    /**
     * 
     * @type {Array<NFSPermission>}
     * @memberof Workspace
     */
    sharingNfsPermissions?: Array<NFSPermission>;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    readonly fullPath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    readonly currentShareName: string;
    /**
     * 
     * @type {Array<WorkspaceEndpoint>}
     * @memberof Workspace
     */
    readonly endpoints?: Array<WorkspaceEndpoint> | null;
    /**
     * 
     * @type {Quota}
     * @memberof Workspace
     */
    quota?: Quota | null;
    /**
     * 
     * @type {number}
     * @memberof Workspace
     */
    readonly sizeUsed: number | null;
    /**
     * 
     * @type {number}
     * @memberof Workspace
     */
    readonly sizeTotal: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    readonly bookmarked: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Workspace
     */
    quotaSizeHard?: number;
    /**
     * 
     * @type {number}
     * @memberof Workspace
     */
    quotaSizeSoft?: number;
    /**
     * 
     * @type {Array<WorkspaceResolvedPermission>}
     * @memberof Workspace
     */
    readonly resolvedPermissions?: Array<WorkspaceResolvedPermission> | null;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    readonly resolvedReadOnly: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    readonly directory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    longDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    isTemplate?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Workspace
     */
    readonly lastLogin?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    macProtocol?: WorkspaceMacProtocolEnum;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    winProtocol?: WorkspaceWinProtocolEnum;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    winDrive?: WorkspaceWinDriveEnum;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    linuxProtocol?: WorkspaceLinuxProtocolEnum;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    linuxMountpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    shareName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    shareNfs?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    shareAfp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    sharingHidden?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    sharingRequireLogin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    sharingReadOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    sharingAllowExecute?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    enableQuota?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    affinity?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    emulateAvid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    emulateCapture?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    emulatePreopen?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    emulateNtfsStreams?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    emulateRecycleBin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    emulateFruit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    smbExtraConfig?: string;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    afpExtraConfig?: string;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    recycleBinExclude?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    isExternal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    externalMacUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    externalWinUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workspace
     */
    externalLinuxUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    allowSymlinks?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workspace
     */
    rwPermissionPriority?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Workspace
     */
    template?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Workspace
     */
    readonly homeFor?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum WorkspaceMacProtocolEnum {
    Smb = 'smb',
    Afp = 'afp',
    Nfs = 'nfs',
    Omfs = 'omfs'
}/**
* @export
* @enum {string}
*/
export enum WorkspaceWinProtocolEnum {
    Disk = 'disk',
    Unc = 'unc'
}/**
* @export
* @enum {string}
*/
export enum WorkspaceWinDriveEnum {
    A = 'a',
    B = 'b',
    C = 'c',
    D = 'd',
    E = 'e',
    F = 'f',
    G = 'g',
    H = 'h',
    I = 'i',
    J = 'j',
    K = 'k',
    L = 'l',
    M = 'm',
    N = 'n',
    O = 'o',
    P = 'p',
    Q = 'q',
    R = 'r',
    S = 's',
    T = 't',
    U = 'u',
    V = 'v',
    W = 'w',
    X = 'x',
    Y = 'y',
    Z = 'z'
}/**
* @export
* @enum {string}
*/
export enum WorkspaceLinuxProtocolEnum {
    Smb = 'smb',
    Nfs = 'nfs'
}

export function WorkspaceFromJSON(json: any): Workspace {
    return WorkspaceFromJSONTyped(json, false);
}

export function WorkspaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Workspace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'production': ProductionMiniReferenceFromJSON(json['production']),
        'volume': !exists(json, 'volume') ? undefined : VolumeMiniReferenceFromJSON(json['volume']),
        'volumePath': !exists(json, 'volume_path') ? undefined : json['volume_path'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'sharingNfsPermissions': !exists(json, 'sharing_nfs_permissions') ? undefined : ((json['sharing_nfs_permissions'] as Array<any>).map(NFSPermissionFromJSON)),
        'fullPath': !exists(json, 'full_path') ? undefined : json['full_path'],
        'currentShareName': json['current_share_name'],
        'endpoints': !exists(json, 'endpoints') ? undefined : (json['endpoints'] === null ? null : (json['endpoints'] as Array<any>).map(WorkspaceEndpointFromJSON)),
        'quota': !exists(json, 'quota') ? undefined : QuotaFromJSON(json['quota']),
        'sizeUsed': json['size_used'],
        'sizeTotal': json['size_total'],
        'bookmarked': json['bookmarked'],
        'quotaSizeHard': !exists(json, 'quota_size_hard') ? undefined : json['quota_size_hard'],
        'quotaSizeSoft': !exists(json, 'quota_size_soft') ? undefined : json['quota_size_soft'],
        'resolvedPermissions': !exists(json, 'resolved_permissions') ? undefined : (json['resolved_permissions'] === null ? null : (json['resolved_permissions'] as Array<any>).map(WorkspaceResolvedPermissionFromJSON)),
        'resolvedReadOnly': json['resolved_read_only'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'directory': !exists(json, 'directory') ? undefined : json['directory'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'longDescription': !exists(json, 'long_description') ? undefined : json['long_description'],
        'isTemplate': !exists(json, 'is_template') ? undefined : json['is_template'],
        'lastLogin': !exists(json, 'last_login') ? undefined : (json['last_login'] === null ? null : new Date(json['last_login'])),
        'active': !exists(json, 'active') ? undefined : json['active'],
        'macProtocol': !exists(json, 'mac_protocol') ? undefined : json['mac_protocol'],
        'winProtocol': !exists(json, 'win_protocol') ? undefined : json['win_protocol'],
        'winDrive': !exists(json, 'win_drive') ? undefined : json['win_drive'],
        'linuxProtocol': !exists(json, 'linux_protocol') ? undefined : json['linux_protocol'],
        'linuxMountpoint': !exists(json, 'linux_mountpoint') ? undefined : json['linux_mountpoint'],
        'shareName': !exists(json, 'share_name') ? undefined : json['share_name'],
        'shareNfs': !exists(json, 'share_nfs') ? undefined : json['share_nfs'],
        'shareAfp': !exists(json, 'share_afp') ? undefined : json['share_afp'],
        'sharingHidden': !exists(json, 'sharing_hidden') ? undefined : json['sharing_hidden'],
        'sharingRequireLogin': !exists(json, 'sharing_require_login') ? undefined : json['sharing_require_login'],
        'sharingReadOnly': !exists(json, 'sharing_read_only') ? undefined : json['sharing_read_only'],
        'sharingAllowExecute': !exists(json, 'sharing_allow_execute') ? undefined : json['sharing_allow_execute'],
        'enableQuota': !exists(json, 'enable_quota') ? undefined : json['enable_quota'],
        'affinity': !exists(json, 'affinity') ? undefined : json['affinity'],
        'emulateAvid': !exists(json, 'emulate_avid') ? undefined : json['emulate_avid'],
        'emulateCapture': !exists(json, 'emulate_capture') ? undefined : json['emulate_capture'],
        'emulatePreopen': !exists(json, 'emulate_preopen') ? undefined : json['emulate_preopen'],
        'emulateNtfsStreams': !exists(json, 'emulate_ntfs_streams') ? undefined : json['emulate_ntfs_streams'],
        'emulateRecycleBin': !exists(json, 'emulate_recycle_bin') ? undefined : json['emulate_recycle_bin'],
        'emulateFruit': !exists(json, 'emulate_fruit') ? undefined : json['emulate_fruit'],
        'smbExtraConfig': !exists(json, 'smb_extra_config') ? undefined : json['smb_extra_config'],
        'afpExtraConfig': !exists(json, 'afp_extra_config') ? undefined : json['afp_extra_config'],
        'recycleBinExclude': !exists(json, 'recycle_bin_exclude') ? undefined : json['recycle_bin_exclude'],
        'isExternal': !exists(json, 'is_external') ? undefined : json['is_external'],
        'externalMacUrl': !exists(json, 'external_mac_url') ? undefined : json['external_mac_url'],
        'externalWinUrl': !exists(json, 'external_win_url') ? undefined : json['external_win_url'],
        'externalLinuxUrl': !exists(json, 'external_linux_url') ? undefined : json['external_linux_url'],
        'allowSymlinks': !exists(json, 'allow_symlinks') ? undefined : json['allow_symlinks'],
        'rwPermissionPriority': !exists(json, 'rw_permission_priority') ? undefined : json['rw_permission_priority'],
        'template': !exists(json, 'template') ? undefined : json['template'],
        'homeFor': !exists(json, 'home_for') ? undefined : json['home_for'],
    };
}

export function WorkspaceToJSON(value?: Workspace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'production': ProductionMiniReferenceToJSON(value.production),
        'volume': VolumeMiniReferenceToJSON(value.volume),
        'sharing_nfs_permissions': value.sharingNfsPermissions === undefined ? undefined : ((value.sharingNfsPermissions as Array<any>).map(NFSPermissionToJSON)),
        'quota': QuotaToJSON(value.quota),
        'quota_size_hard': value.quotaSizeHard,
        'quota_size_soft': value.quotaSizeSoft,
        'name': value.name,
        'description': value.description,
        'long_description': value.longDescription,
        'is_template': value.isTemplate,
        'active': value.active,
        'mac_protocol': value.macProtocol,
        'win_protocol': value.winProtocol,
        'win_drive': value.winDrive,
        'linux_protocol': value.linuxProtocol,
        'linux_mountpoint': value.linuxMountpoint,
        'share_name': value.shareName,
        'share_nfs': value.shareNfs,
        'share_afp': value.shareAfp,
        'sharing_hidden': value.sharingHidden,
        'sharing_require_login': value.sharingRequireLogin,
        'sharing_read_only': value.sharingReadOnly,
        'sharing_allow_execute': value.sharingAllowExecute,
        'enable_quota': value.enableQuota,
        'affinity': value.affinity,
        'emulate_avid': value.emulateAvid,
        'emulate_capture': value.emulateCapture,
        'emulate_preopen': value.emulatePreopen,
        'emulate_ntfs_streams': value.emulateNtfsStreams,
        'emulate_recycle_bin': value.emulateRecycleBin,
        'emulate_fruit': value.emulateFruit,
        'smb_extra_config': value.smbExtraConfig,
        'afp_extra_config': value.afpExtraConfig,
        'recycle_bin_exclude': value.recycleBinExclude,
        'is_external': value.isExternal,
        'external_mac_url': value.externalMacUrl,
        'external_win_url': value.externalWinUrl,
        'external_linux_url': value.externalLinuxUrl,
        'allow_symlinks': value.allowSymlinks,
        'rw_permission_priority': value.rwPermissionPriority,
        'template': value.template,
    };
}


